// src/components/UserMenu.jsx
import React from 'react';
import {
  IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Avatar, Divider, Dialog,
  DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { FaUser, FaKey, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function UserMenu({ displayName = 'Usuario', onLogout }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const initials = React.useMemo(() => {
    const parts = String(displayName).trim().split(' ');
    const i1 = parts[0]?.[0] ?? '';
    const i2 = parts[1]?.[0] ?? '';
    return (i1 + i2).toUpperCase();
  }, [displayName]);

  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const goPerfil = () => { handleClose(); navigate('/perfil'); };
  const goChangePw = () => { handleClose(); navigate('/cambiar-clave'); };
  const askLogout = () => { handleClose(); setOpenConfirm(true); };
  const doLogout = () => { setOpenConfirm(false); onLogout?.(); };

  return (
    <>
      <Tooltip title="Cuenta">
        <IconButton onClick={handleMenu} size="small" sx={{ ml: 1 }}>
          <Avatar sx={{ width: 32, height: 32 }}>{initials || 'U'}</Avatar>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ elevation: 3 }}
      >
        <MenuItem onClick={goPerfil}>
          <ListItemIcon><FaUser size={16} /></ListItemIcon>
          <ListItemText>Perfil</ListItemText>
        </MenuItem>
        <MenuItem onClick={goChangePw}>
          <ListItemIcon><FaKey size={16} /></ListItemIcon>
          <ListItemText>Cambiar contraseña</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={askLogout} sx={{ color: '#ff5656' }}>
          <ListItemIcon><FaSignOutAlt size={16} color="#ff5656" /></ListItemIcon>
          <ListItemText>Cerrar sesión</ListItemText>
        </MenuItem>
      </Menu>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirmar</DialogTitle>
        <DialogContent>¿Deseas cerrar sesión?</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancelar</Button>
          <Button variant="contained" color="error" onClick={doLogout}>Cerrar sesión</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
